import { useAuth } from "@home-health-notify/auth";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DomainContext, useTranslation } from "hhn-commons";
import { useContext, useEffect, useState } from "react";

import { getHomeRoute } from "../utils/sessionRoute";

export const MultiTabAuthSync = () => {
  const { domain } = useContext(DomainContext);
  const { isLoggedIn } = useAuth();
  const { t } = useTranslation();
  const tns = (key: string) => t(key, { ns: "login" });
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    return domain.subscribeToCrossTabAuthChanges(otherTabAuthenticated => {
      if (otherTabAuthenticated !== isLoggedIn) {
        setIsStale(true);
      }
    });
    // Re-subscribe when isLoggedIn changes so the closure sees the latest value.
  }, [domain, isLoggedIn]);

  return (
    <Dialog
      open={isStale}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
      }}
    >
      <DialogTitle>{tns("sessionChangedTitle")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{tns("sessionChangedMessage")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            window.location.href = getHomeRoute();
          }}
        >
          {tns("sessionChangedReload")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
